module.exports = __webpack_public_path__ + "media/img/about/person/yunita-695e1d61d883f1074868859a85ea9b3e.webp";